module.exports = __webpack_public_path__ + "img/header.4d42674c.png";